import React from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from './Style_data/Login.module.css'; // 스타일 임포트

function Login() {
  const navigate = useNavigate();

  const handleKakaoLogin = () => {
    const K_REST_API_KEY = '0ec3b8df71a5ddd4d3615c7edd57cbe4';
    const K_REDIRECT_URI = encodeURIComponent('http://localhost:3000/login/kakao/callback');
    const kakaoURL = `https://kauth.kakao.com/oauth/authorize?client_id=${K_REST_API_KEY}&redirect_uri=${K_REDIRECT_URI}&response_type=code`;
    window.location.href = kakaoURL;
  };


  const handleNaverLogin = () => {
    const clientId = '5cf4VXIBu3T1puLX4zpy'; // 네이버 개발자 센터에서 발급받은 clientId
    const redirectUri = encodeURIComponent('http://localhost:3000/login/naver/callback');
    const state = Math.random().toString(36).substring(7); // CSRF 공격 방지를 위한 임의의 문자열

    const naverLoginUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;
    window.location.href = naverLoginUrl;
  };

  const handleJoinClick = () => {
    navigate('/join');
  };

  return (
    <div className={Styles.parent}>
      <div className={Styles.childStyle}>
        <form>
          <div className={Styles.rowStyle}>
            <label className={Styles.label} htmlFor="senior">시니어랑</label>
          </div>
          <div className={Styles.loginRow}>
            <div className={Styles.inputGroup}>
              <input type="text" placeholder="아이디" className={Styles.input} />
              <input type="password" placeholder="비밀번호" className={Styles.input} />
            </div>
            <button className={Styles.loginButton}>로그인</button>
          </div>

          
          <div className="checkbox">
            <input type="checkbox" id="auto-login" />
            <label htmlFor="auto-login">아이디 저장</label>
          </div>
          <div className="social-login">
            <button type="button" className="social-button nevi" onClick={handleNaverLogin}>네이버로 로그인</button>
            <button type="button" className="social-button kakao" onClick={handleKakaoLogin}>카카오로 로그인</button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0' }}>
            <button type="button" className={Styles['button']} onClick={handleJoinClick}>회원가입</button>
            <button type="button" className={Styles['button']}>비밀번호 찾기</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
